import Link from 'next/link'
import { AdminClient } from '@/components/admin/AdminClient'
import { LoadFailed, Loading, NotFound } from '@/components/shell/Loading'
import { useApi, useMe } from '@/lib/api'

type AdminPayload = React.ComponentProps<typeof AdminClient>

/** The platform view. A non-admin gets a 404, as the API answers 403 and the page says nothing. */
export function AdminPage() {
  const me = useMe()
  const data = useApi<AdminPayload>(me.data?.isPlatformAdmin ? '/api/admin' : null)
  if (me.isPending) return <Loading />
  if (!me.data?.isPlatformAdmin) return <NotFound />
  if (data.isPending) return <Loading />
  if (data.isError) return <LoadFailed error={data.error} retry={() => void data.refetch()} />
  return (
    <div className="mx-auto w-full max-w-6xl px-5 py-8 sm:px-8 sm:py-10">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-[11px] font-medium uppercase tracking-[0.08em] text-muted">ROUTR</p>
          <h1 className="text-2xl font-semibold tracking-tight sm:text-[1.75rem]">Admin</h1>
          <p className="mt-1.5 text-sm text-muted">Everyone using ROUTR, and everything they have reported. Read-only, except for closing feedback.</p>
        </div>
        <Link href="/" className="text-[11px] text-muted underline underline-offset-2 hover:text-foreground">
          Back to the app
        </Link>
      </div>
      <AdminClient {...data.data!} />
    </div>
  )
}
